/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'equip': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M1.701 1.701v1020.598h1020.598V1.701zm935.548 85.05V324.04H86.751V86.75zm0 324.04V631.07H86.751V409.09zM86.751 937.249V716.12h850.498v221.13z"/><path pid="1" d="M147.136 164.997h163.296v85.05H147.136zm0 304.478h163.296v85.05H147.136zm0 315.535h163.296v85.05H147.136z"/>'
  }
})
